module.exports = __webpack_public_path__ + "img/placeholder/site-nav-brand-tram.svg";